import { autoJsStoreUtils } from "@droid/android"
import { IStoreWithData, storeUtils, toProxy } from "@fanfanlo"
import { IAndroidWatchFile, IMarketDevConnectEventType, IMarketDevGetAllEventData, IMarketDevServerEventType, WatchResourceType } from "@market/lib"
import { marketsDevSocket } from "./market-dev-socket"
import { objectCountUtils } from "@fanfanlo"
interface IMarketDevLibInfo{
    allMarketLibData?:IMarketDevGetAllEventData
    
}
// 注意marketDevLibData的操作是由devLibInfo来做的
// 一定保持它俩操作的对象是同一个。
const marketDevLibData = toProxy<IMarketDevLibInfo>({})
let devLibInfo:IStoreWithData<IMarketDevLibInfo>// = storeUtils.getNamespaceStoreWithData('devLibInfo', {defData:{}, forceReset:false});

function getMarketScriptDataNsPrefix() {
    return 'market-script-data'
}

function createMarketScriptDataNsPath(ns: string) {
    return `${getMarketScriptDataNsPrefix()}/${ns}`
}

async function writeNsAllFiles(ns: string, files: Record<string, string>) {
    const nsPath = createMarketScriptDataNsPath(ns)
    const oldFiles = autoJsStoreUtils.read<string[]>(nsPath) || [];
    for (const name of Object.keys(files)) {
        const index = oldFiles.indexOf(name);
        if (index > -1) {
            oldFiles.splice(index, 1);
        }
        const content = files[name]
        autoJsStoreUtils.write(`${nsPath}/${name}`, content)
    }
    for (const name of oldFiles) {
        removeFile(`${nsPath}/${name}`)
    }
}

function writeFile(name: string, content: string) {

}

function readNsAllFiles(ns: string) {

}

function readFile(name: string) {

}

function removeFile(name: string) {

}

function getAllMarkets() {

}
function listenDev(){
    marketsDevSocket.dispatcher.addListener(IMarketDevConnectEventType.getAllScripts, onGetAllScript)
    marketsDevSocket.dispatcher.addListener(IMarketDevServerEventType.update, onFileUpdate)    
}

function onGetAllScript(data:IMarketDevGetAllEventData){
    // console.log('onGetAllScript=2', data)
    // console.log('devLibInfo.data=', devLibInfo.data)
    devLibInfo.data.allMarketLibData = data;
    // 转为已经代理过的对象
    marketDevLibData.allMarketLibData = devLibInfo.data.allMarketLibData;
    // console.log('from onGetAllScript look look id', objectCountUtils.getObjectCount(devLibInfo.data.allMarketLibData.resources))
}

function onFileUpdate(data:IAndroidWatchFile){
    if(data.client.resourceType == WatchResourceType.Html){
        if(!devLibInfo.data.allMarketLibData)return;
        for(const html of devLibInfo.data.allMarketLibData.htmls){
            if(html.client.path == data.client.path){
                html.content = data.content;
                return;
            }
        }
    }else if(data.client.resourceType == WatchResourceType.Js){
        if(!devLibInfo.data.allMarketLibData)return;
        for(let index = 0; index < devLibInfo.data.allMarketLibData.resources.length; index ++){
            const script = devLibInfo.data.allMarketLibData.resources[index];
            if(script.client.path == data.client.path){
                devLibInfo.data.allMarketLibData.resources[index] = data;
                console.log('market script dev scripts update script', data)
                // devLibInfo.data.allMarketLibData.resources = [...devLibInfo.data.allMarketLibData.resources];
                // console.log('update data', data);
                // console.log('look look id', objectCountUtils.getObjectCount(devLibInfo.data.allMarketLibData.resources), devLibInfo.data.allMarketLibData.resources)
                return;
            }
        }
    }else{
        // unknown resource type
    }
}
let isInitialized = false;
async function init() {
    if(isInitialized){
        return;
    }
    isInitialized = true;
    listenDev();
    devLibInfo = await storeUtils.getNamespaceStoreWithData('devLibInfo', {defData:{}, forceReset:false});
    marketDevLibData.allMarketLibData = devLibInfo.data.allMarketLibData
}
export const marketsDevScriptLib = {
    writeFile,
    readFile,
    writeNsAllFiles,
    readNsAllFiles,
    getAllMarkets,
    init,
    marketDevLibData,
}
